import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Player from "../components/Player/Player";
import { useStateContext } from "../contexts/ContextProvider";

import MobileBanner from "../components/NativeBanner/MobileBanner";
import DesktopBanner from "../components/NativeBanner/DesktopBanner";

function App() {
  const { contestId, id } = useParams();
  const { songs, contest, loading, getSongs, currentRound } = useStateContext();
  const navigate = useNavigate();
  const [buttonText, setButtonText] = useState("Vote");
  const [isMobile, setIsMobile] = useState(true);

  let currentSong = parseInt(id) - 1;
  switch (parseInt(id)) {
    case 1:
      break;
    case 2:
      currentSong = parseInt(id);
      break;
    case 3:
      currentSong = parseInt(id) + 1;
      break;
    case 4:
      currentSong = parseInt(id) + 2;
      break;
    default:
  }

  const [currentSongIndex, setCurrentSongIndex] = useState(currentSong);
  const [nextSongIndex, setNextSongIndex] = useState(currentSong + 1);

  const getLocalStorage = () => {
    for (let i = 1; i <= 5; i++) {
      let contestData = localStorage.getItem(
        `${contestId.toString()}_${currentRound}`
      );
      let contestDataValue = JSON.parse(contestData);
      // console.log("contestData: " + contestDataValue);

      if (contestDataValue) {
        if (i === 5) {
          navigate(`/final/${contestId}`);
        }
      }
      console.log("i = ", i);
      console.log("id = ", id);
      if (contestDataValue) {
        if (!contestDataValue[i.toString()]) {
          if (parseInt(id) >= i) {
            break;
          }
          switch (i) {
            case 1: // SongPage
              navigate(`/song/${i}/${contestId}`);
              break;
            case 2: // SongPage
              navigate(`/song/${i + 1}/${contestId}`);
              break;
            case 3: // SongPage
              navigate(`/song/${i + 2}/${contestId}`);
              break;
            case 4: // SongPage
              navigate(`/song/${i + 3}/${contestId}`);
              break;
            default:
          }
          break;
        }
      }
    }
  };

  useEffect(() => {
    if (!window.matchMedia("(max-width: 688px)").matches) {
      setIsMobile(false);
    }
    getSongs(contestId);
    getLocalStorage();
    setNextSongIndex(() => {
      if (currentSongIndex + 1 > songs.length - 1) {
        return 0;
      } else {
        return currentSongIndex + 1;
      }
    });
  }, [currentSongIndex, contestId, currentRound]);

  const nextPage = () => {
    for (let i = 50; i >= 0; i--) {
      window.clearTimeout(i);
    }
    switch (parseInt(id)) {
      case 1: // SongPage
        navigate(`/song/${parseInt(id) + 2}/${contestId}`);
        break;
      case 2: // SongPage
        navigate(`/song/${parseInt(id) + 3}/${contestId}`);
        break;
      case 3: // SongPage
        navigate(`/song/${parseInt(id) + 4}/${contestId}`);
        break;
      case 4: // ClosingPage
        navigate(`/final/${contestId}`);
        break;
      default:
    }
  };

  const sendVoting = async (e) => {
    e.preventDefault();

    try {
      const data = {
        contestId: contest,
        matchId: e.target.value,
        artistVote: e.target.id,
      };
      // console.log(data);
      const response = await axios(
        {
          method: "post",
          url: `${process.env.REACT_APP_BACKEND_API_SERVER}/voteSong`,
          data: data,
          mode: "no-cors",
        },
        { withCredentials: true }
      );
      const res = response.data;
      console.log(res);

      // Save voting information to localStorage
      let contestData = localStorage.getItem(
        `${contestId.toString()}_${currentRound}`
      );
      let contestDataValue = JSON.parse(contestData);
      let matchVote = {};
      matchVote[id] = e.target.id;
      let temp = { ...contestDataValue, ...matchVote };

      localStorage.setItem(
        `${contestId}_${currentRound}`,
        JSON.stringify(temp)
      );

      // Redirect when vote submitted successfully
      if (res.message === "success") {
        nextPage();
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (loading || songs.length === 0) return <p>Loading...</p>;

  if (songs.length > 0) {
    // console.log(songs);

    return (
      <>
        {isMobile ? <MobileBanner /> : <DesktopBanner />}
        <p
          onClick={() => {
            navigate("/");
          }}
          className="text-white text-xl font-bold pt-12 lg:-mb-20 text-center cursor-pointer"
        >
          {songs[currentSongIndex].matchName}: Vote For Your Favorite
        </p>
        <div className="App flex-wrap">
          {0 < id && id < 5 ? (
            <>
              <div className="lg:w-fit w-full mx-16">
                <Player
                  currentSongIndex={currentSongIndex}
                  setCurrentSongIndex={setCurrentSongIndex}
                  nextSongIndex={nextSongIndex}
                  songs={songs}
                  buttonText={buttonText}
                  sendVoting={sendVoting}
                  id={1}
                />
              </div>
              <div className="votingLogo">
                <img
                  src="/images/vs.png"
                  alt=""
                  className="md:w-full h-auto mt-8 lg:mx-16"
                />
              </div>
              <div className="lg:w-fit w-full mx-16">
                <Player
                  currentSongIndex={currentSongIndex + 1}
                  setCurrentSongIndex={setCurrentSongIndex}
                  nextSongIndex={currentSongIndex + 2}
                  songs={songs}
                  buttonText={buttonText}
                  sendVoting={sendVoting}
                  id={2}
                />
              </div>
            </>
          ) : (
            <span style={{ color: "white" }}>PAGE NOT FOUND</span>
          )}
        </div>
      </>
    );
  }
}

export default App;
